/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = function _default(str) {
  if (typeof str == 'string' && str.length < 2) {
    return str.length ? "0".concat(str) : '00';
  }
  if (typeof str == 'number') {
    return str < 10 ? "0".concat(str) : "".concat(str);
  }
  return str;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/utils/leftPad.js
// module id = 154
// module chunks = 0